import { useFocusEffect, useNavigation } from 'expo-router';
import { useCallback, useLayoutEffect } from 'react';
import { Platform, StyleSheet, useWindowDimensions, View } from 'react-native';
import { FlatList } from 'react-native-gesture-handler';
import { Divider } from 'react-native-paper';

import { useGetSubscriptionListScrolling } from '@/api/hooks/paymentAccountsHooks';
import GoBackButton from '@/components/buttons/GoBackButton';
import DotsLoader from '@/components/DotsLoader';
import ListEmptyComponent from '@/components/ListEmptyComponent';
import NextPageFetchingIndicator from '@/components/NextPageFetchingIndicator';
import SubscriptionItemView from '@/components/paymentMethods/SubscriptionItemView';
import Title from '@/components/Title';
import { i18n } from '@/utils/i18n';

const Subscriptions = () => {
  const { height } = useWindowDimensions();
  const navigation = useNavigation();

  const { data, isPending, isFetching, isFetchingNextPage, fetchNextPage, hasNextPage, refetch, isRefetching } =
    useGetSubscriptionListScrolling({
      limit: 10
    });

  const subscriptions = data?.pages.flatMap((page) => page.results);

  //Locales
  const title = i18n.t('settings.screen_names.subscriptions');

  useLayoutEffect(() => {
    navigation.setOptions({
      headerTitle: () => <Title label={title} />,
      headerLeft: () => <GoBackButton />
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigation]);

  useFocusEffect(
    useCallback(() => {
      refetch();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
  );

  return (
    <View style={[styles.mainContainer, Platform.OS === 'web' ? { height: height - 69 } : { flex: 1 }]}>
      {isPending ? (
        <DotsLoader />
      ) : (
        <FlatList
          style={styles.fullWidth}
          showsVerticalScrollIndicator={false}
          data={subscriptions}
          scrollEnabled={true}
          keyExtractor={(item) => item.id}
          onEndReachedThreshold={0.7}
          onEndReached={(_) => {
            hasNextPage && !isFetching && fetchNextPage();
          }}
          onRefresh={refetch}
          refreshing={isRefetching}
          renderItem={({ item }) => <SubscriptionItemView subscriptionItem={item} onDelete={refetch} />}
          ItemSeparatorComponent={() => <Divider style={styles.divider} />}
          ListFooterComponent={isFetchingNextPage ? <NextPageFetchingIndicator /> : null}
          ListEmptyComponent={<ListEmptyComponent label={i18n.t('donation.subscription_empty_list')} />}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  mainContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%'
  },

  fullWidth: {
    width: '100%'
  },

  divider: {
    marginVertical: 15
  },

  emptyList: {
    alignSelf: 'center',
    marginVertical: 25
  }
});

export default Subscriptions;
